import React from "react";

import Guest from "../../../layouts/Guest";
import ChingMingCheckAdminForm from "views/Forms/Private/EventCheckForm/ChingMingCheckAdminForm";

function EventCheckInSearchPage() {

  return (
    <>
      <Guest>
        <ChingMingCheckAdminForm />
      </Guest>
    </>
  );
}

export default EventCheckInSearchPage;
